<template>
  <el-tabs type="border-card" v-model="activeTabName">
    <el-tab-pane label="录入" name="first">
      <el-form
        :model="categoryForm"
        :rules="rules"
        ref="categoryForm"
        label-width="100px"
      >
        <el-form-item label="公司名称" style="margin-top: -0.2rem">
          <span style="font-size: 0.28rem">{{ comName }}</span>
        </el-form-item>
        <el-form-item label="分类名称" prop="categoryId">
          <el-select
            size="mini"
            v-model="categoryForm.categoryId"
            clearable
            placeholder="请选择分类"
            style="width: 100%"
            @click.native="getCate"
            filterable
          >
            <el-option
              v-for="item in cateOptions"
              :key="item.id"
              :label="item.category_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="建议内容" prop="body">
          <el-input
            size="mini"
            type="textarea"
            v-model="categoryForm.body"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传截图" prop="url">
          <el-upload
            action="https://weixin.qiyehuo.com/api/advice/upscr"
            :headers="header"
            ref="uploadMutiple"
            multiple
            list-type="picture-card"
            :file-list="fileList"
            :limit="limit"
            accept="image/jpeg,image/jpg,image/png"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
            :on-change="handleAvatarChange"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div style="margin-top: 0.2rem">
            <span
              ><i class="el-icon-s-opportunity" style="color: #fb894c"
                >点击下方，Ctrl+v上传</i
              ></span
            >
          </div>
          <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
          <div
            id="preview"
            @paste="handlePaste"
            style="
              border: 3px dashed #409eff;
              border-radius: 15px;
              text-indent: 2em;
            "
          >
            <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
          </div>
          <el-dialog :visible.sync="dialogVisible" :modal="false">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <div style="text-align: right">
          <el-button
            type="primary"
            size="mini"
            @click="submitForm('categoryForm')"
            >添加</el-button
          >
        </div>
      </el-form>
    </el-tab-pane>
    <el-tab-pane name="second">
      <template slot="label">
        <div
          style="width: 1.6rem; height: 0.74rem; text-align: center"
          @click="loadSingle"
        >
          建议列表
        </div>
      </template>
      <el-drawer
        title="修改"
        :visible.sync="categoryEditDrawer"
        :direction="direction"
        :before-close="handleClose"
        :append-to-body="true"
        size="40%"
      >
        <div style="padding: 0.2em 1.4em; margin-top: -17px">
          <el-form
            :model="categoryEditForm"
            :rules="rules"
            ref="categoryEditForm"
            label-width="100px"
          >
            <el-form-item label="公司名称" style="margin-top: -0.4rem">
              <span style="font-size: 0.28rem">{{ other.company_name }}</span>
            </el-form-item>
            <el-form-item label="月份" style="margin-top: -0.4rem">
              <span style="font-size: 0.25rem">{{ other.month }}</span>
            </el-form-item>
            <el-form-item
              label="分类名称"
              prop="categoryId"
              style="margin-top: -0.4rem"
            >
              <!-- <el-select
              v-model="categoryEditForm.categoryId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入搜索分类名称"
              size="mini"
              clearable
              :remote-method="searchRemoteCfbodyEdit"
              :loading="searchLoading"
              style="width: 100%"
            >
              <el-option
                v-for="searchCompany in searchEditBodies"
                :key="searchCompany.id"
                :label="searchCompany.category_name"
                :value="searchCompany.id"
              >
              </el-option>
            </el-select> -->
              <el-select
                size="mini"
                v-model="categoryEditForm.categoryId"
                clearable
                placeholder="请选择分类"
                style="width: 100%"
                @click.native="getCateEdit"
                filterable
              >
                <el-option
                  v-for="item in cateEditOptions"
                  :key="item.id"
                  :label="item.category_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="建议内容" prop="body">
              <el-input
                size="mini"
                type="textarea"
                v-model="categoryEditForm.body"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传截图" prop="url">
              <el-upload
                action="https://weixin.qiyehuo.com/api/advice/upscr"
                :headers="header"
                multiple
                ref="editUploadMutiple"
                list-type="picture-card"
                :file-list="editFileList"
                :limit="limit"
                accept="image/jpeg,image/jpg,image/png"
                :before-upload="beforeAvatarUpload"
                :on-success="editHandleAvatarSuccess"
                :on-change="editHandleAvatarChange"
                :on-preview="editHandlePictureCardPreview"
                :on-remove="editHandleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div style="margin-top: 0.2rem">
                <span
                  ><i class="el-icon-s-opportunity" style="color: #fb894c"
                    >点击下方，Ctrl+v上传</i
                  ></span
                >
              </div>
              <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
              <div
                id="previewE"
                @paste="editHandlePaste"
                style="
                  border: 3px dashed #409eff;
                  border-radius: 15px;
                  text-indent: 2em;
                "
              >
                <span style="opacity: 0.5"
                  >先点击此处 再按Ctrl+V 粘贴至此处</span
                >
              </div>
              <el-dialog :visible.sync="dialogVisibleE" :modal="false">
                <img width="100%" :src="dialogImageUrlE" alt="" />
              </el-dialog>
            </el-form-item>
            <div style="text-align: right">
              <el-button
                type="primary"
                size="mini"
                @click="editSubmitForm('categoryEditForm')"
                >修改</el-button
              >
            </div>
          </el-form>
        </div>
      </el-drawer>
      <div style="display: flex">
        <el-popover placement="bottom" width="300" trigger="click" v-model="visible">
          <el-form
            ref="searchForm"
            :model="searchForm"
            label-width="80px"
          >
            <el-form-item label="选择月份" prop="month">
              <el-date-picker
                v-model="searchForm.month"
                type="month"
                placeholder="选择月份"
                size="mini"
                value-format="yyyy-MM"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="建议人" prop="advice_name">
              <el-select
                v-model="searchForm.advice_name"
                clearable
                placeholder="请选择"
                size="mini"
                filterable
                @click.native="loadAdvice"
                style="width: 100%"
              >
                <el-option
                  v-for="item in adviceNameOptions"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="建议类型" prop="advice_cate">
              <el-select
                v-model="searchForm.advice_cate"
                clearable
                placeholder="请选择"
                size="mini"
                filterable
                @click.native="loadAdviceCate"
                style="width: 100%"
              >
                <el-option
                  v-for="item in adviceCateOptions"
                  :key="item.id"
                  :label="item.category_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否阅读" prop="is_read">
              <el-radio-group v-model="searchForm.is_read" size="mini">
                <el-radio-button :label="'0'">未阅读</el-radio-button>
                <el-radio-button :label="1">已阅读</el-radio-button>
                <el-radio-button :label="2">未知</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否认同" prop="is_agree">
              <el-radio-group v-model="searchForm.is_agree" size="mini">
                <el-radio-button :label="'0'">不认同</el-radio-button>
                <el-radio-button :label="1">认同</el-radio-button>
                <el-radio-button :label="2">未知</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="采纳案例" prop="is_use">
              <el-radio-group v-model="searchForm.is_use" size="mini">
                <el-radio-button :label="1">是</el-radio-button>
                <el-radio-button :label="'0'">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <div style="text-align: right">
              <el-button
                type="info"
                @click="resetForm('searchForm')"
                size="mini"
                >重置</el-button
              >
              <el-button type="primary" @click="doSearch" size="mini"
                >查询</el-button
              >
            </div>
          </el-form>
          <el-button slot="reference" size="mini"
            >筛选</el-button
          >
        </el-popover>
        <!-- <el-select
        v-model="searchArr.title"
        filterable
        remote
        reserve-keyword
        placeholder="请输入标题名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfTitle"
        :loading="searchLoading"
        @change="handleSearchCfTitle"
      >
        <el-option
          v-for="searchCompany in searchTitles"
          :key="searchCompany.id"
          :label="searchCompany.title"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select> -->
      </div>
      <el-row style="margin-top: 0.2rem">
        <el-col :span="4"> 累计建议:{{ countAdvice }} </el-col>
        <el-col :span="4"> 客户阅读:{{ countRead }} </el-col>
        <el-col :span="4"> 客户认同:{{ countAgree }} </el-col>
        <el-col :span="4"> 客户反对:{{ countNotAgree }} </el-col>
      </el-row>
      <el-table
        max-height="310"
        :data="singleAdviceData"
        style="width: 100%; margin-top: 10px"
        border
        size="mini"
        :header-cell-style="{
          background: '#ecf4ff',
          color: '#333',
          fontWeight: '900',
          fontSize: '0.28rem',
        }"
      >
        <!-- <el-table-column
          prop="company_name"
          label="公司名称"
          width="250"
          fixed="left"
        >
          <template slot-scope="scope">
            <el-link
              style="color: #409eff; font-size: 0.28rem; cursor: pointer"
              @click="openCompanyCom(scope.row)"
            >
              {{ scope.row.company_name }}
            </el-link>
          </template>
        </el-table-column> -->
        <el-table-column prop="cate_name" label="类型">
          <!-- <template slot="header">
            类型
            <span>
              <a href="/advice_cate">
                <el-link style="color: #409eff; margin-left: 0.4rem"
                  >添加类型</el-link
                >
              </a>
            </span>
          </template> -->
        </el-table-column>
        <el-table-column prop="created_at" label="月份" width="150">
        </el-table-column>
        <el-table-column prop="advice_name" label="建议人" width="100">
        </el-table-column>
        <el-table-column prop="is_read" label="客户阅读" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.is_read === '已阅读'">
              {{ scope.row.readed_at }}
            </span>
            <span v-else>
              {{ scope.row.is_read }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="is_agree" label="客户认同" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.is_agree === '认同'">
              认同，认同时间：<br />
              {{ scope.row.agreed_at }}
            </span>
            <span v-else-if="scope.row.is_agree === '不认同'">
              反对，反对时间：<br />
              {{ scope.row.disagreed_at }}
            </span>
            <span v-else>
              {{ scope.row.is_agree }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
            >
              <el-button
                @click.native.prevent="editRow(scope.$index, singleAdviceData)"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
              >
              </el-button>
            </el-tooltip>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <el-button
                @click.native.prevent="deleteRow(scope.$index, categoryData)"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
              >
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="阅读记录"
              placement="top"
            >
              <el-button
                @click.native.prevent="readRow(scope.$index, categoryData)"
                type="success"
                size="mini"
                icon="el-icon-notebook-2"
                circle
              >
              </el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: 'TaxAdvice',
  props: {
    comId: Number,
    comName: String
  },
  data () {
    var categoryId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    var checkbody = (rule, value, callback) => {
      if (value.length > 500) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入建议内容！'))
      }
      callback()
    }
    var checkCompany = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择公司！'))
      }
      callback()
    }
    return {
      visible: false,
      searchArr: {
        title: ''
      },
      searchForm: {
        advice_name: '',
        advice_cate: '',
        is_read: '',
        is_agree: '',
        month: '',
        companyId: '',
        is_use: ''
      },
      needUrl: [],
      activeTabName: 'first',
      editNeedUrl: [],
      npage: 1,
      categoryPerPage: 10,
      total: null,
      categoryData: [],
      searchTitles: [],
      searchBodies: [],
      searchEditBodies: [],
      roleOptions: [],
      cateOptions: [],
      cateEditOptions: [],
      roleEditOptions: [],
      dateCountData: [],
      fileReadRecOptions: [],
      searcher: null,
      singleAdviceData: [],
      categoryEditDrawer: false,
      categoryReadDrawer: false,
      searchLoading: false,
      searchCompanies: [],
      searchCompaniesx: [],
      searchCategories: [],
      categoryIndrawer: false,
      countSuccess: 0,
      editIfDisplay: false,
      direction: 'rtl',
      category: '',
      ideCateId: null,
      ifdisplay: false,
      companyInfoDrawer: false,
      companyComId: null,
      countAdvice: '',
      countRead: '',
      countAgree: '',
      countNotAgree: '',
      change: false,
      api: 'api/advice/upscr',
      header: {
        Authorization: localStorage.getItem('token')
      },
      limit: 3,
      formData: {},
      fileList: [],
      editFileList: [],
      dialogImageUrl: '',
      dialogImageUrlE: '',
      dialogVisible: false,
      dialogVisibleE: false,
      adviceNameOptions: [],
      adviceCateOptions: [],
      ifuse: [],
      categoryForm: {
        categoryId: '',
        body: '',
        companyId: ''
      },
      other: {
        company_name: '',
        month: ''
      },
      categoryEditForm: {
        categoryId: '',
        body: '',
        companyId: ''
      },
      editCategoryForm: {
        categoryId: '',
        category_name: ''
      },
      rules: {
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ],
        body: [
          {
            validator: checkbody,
            trigger: 'blur'
          }
        ],
        companyId: [
          {
            validator: checkCompany,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    // this.loadTable()
    this.loadCategory()
    this.loadAdvice()
    this.loadAdviceCate()
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    loadSingle () {
      this.$axios
        .get('api/advice/sinadvice?company_id=' + this.comId, {
          params: {
            searchItem: this.searchForm
          }
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.singleAdviceData = data.data
            this.countAdvice = data.count.countTotal
            this.countRead = data.count.countRead
            this.countAgree = data.count.countAgree
            this.countNotAgree = data.count.countNotAgree
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadAdviceCate () {
      this.$axios
        .get('api/advice/getcate')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.adviceCateOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadAdvice () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.adviceNameOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadCategory () {
      this.$axios
        .get('api/advice/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.cateEditOptions = data.data
          }
        })
        .catch()
    },
    loadTable () {
      this.$axios
        .get('api/advice/index', {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searchForm
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.total = data.data.total
            this.countAdvice = data.data.total
            this.countRead = data.count.countRead
            this.countAgree = data.count.countAgree
            this.countNotAgree = data.count.countNotAgree
            this.setExa()
          }
        })
        .catch()
    },
    setExa () {
      this.categoryData.map((item, index) => {
        if (item.is_use === 1) {
          this.ifuse[index] = 1
        } else {
          this.ifuse[index] = 0
        }
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.editFileList = []
      this.$axios
        .get('api/advice/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.other.company_name = data.data.company_name
            this.other.month = data.data.month
            this.categoryEditForm.categoryId = data.data.cate.cate_id
            this.ideCateId = data.data.cate.cate_id
            this.categoryEditForm.body = data.data.body
            this.category = data.data.id
            var fileUrl = data.data.file.map(item => {
              return item
            })
            this.editFileList = fileUrl
          }
        })
        .catch()
      this.categoryEditDrawer = true
    },
    readRow (index, data) {
      this.$axios
        .get('api/advice/getrecord', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.fileReadRecOptions = data.data
          }
        })
        .catch()
      this.categoryReadDrawer = true
    },
    deleteRow (index, data) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axios
            .delete('api/advice/del', {
              params: {
                id: data[index].id
              }
            })
            .then(({ data }) => {
              if (data.code === 1) {
                this.loadTable()
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/advice/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    searchRemoteCfTitle (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemTitle(query)
        }, 200)
      } else {
        this.searchtitles = []
      }
    },
    searchItemTitle (query) {
      this.$axios
        .get('api/advice/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchTitles = data.data
          }
        })
        .catch()
    },
    searchRemoteCfbody (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemBody(query)
        }, 200)
      } else {
        this.searchBodies = []
      }
    },
    searchItemBody (query) {
      this.$axios
        .get('api/cloudfile/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchBodies = data.data
          }
        })
        .catch()
    },
    searchRemoteCfbodyEdit (query) {
      if (query !== '') {
        this.ideCateId = null
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemBodyEdit(query)
        }, 200)
      } else {
        this.searchEditBodies = []
      }
    },
    searchItemBodyEdit (query) {
      this.$axios
        .get('api/cloudfile/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchEditBodies = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleSearchCfTitle (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleSearchCfBody (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleCloseIn (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$refs.categoryForm.resetFields()
          this.$refs.uploadMutiple.clearFiles()
          this.needUrl = []
          done()
        })
        .catch(_ => {})
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.editFileList = []
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.categoryForm.file = this.needUrl
          this.categoryForm.companyId = this.comId
          this.$axios
            .post('api/advice/store', this.categoryForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$refs.categoryForm.resetFields()
                this.$refs.uploadMutiple.clearFiles()
                this.needUrl = []
                this.$message.success(data.msg)
                this.categoryIndrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var oldId = this.editFileList.map(item => {
            return item.id
          })
          this.$axios
            .put('api/advice/edit', {
              id: this.category,
              ideCateId: this.ideCateId,
              cateId: this.categoryEditForm.categoryId,
              body: this.categoryEditForm.body,
              oldId: oldId,
              change: this.change,
              newFile: this.editNeedUrl
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.editNeedUrl = []
                this.editFileList = []
                this.change = false
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadSingle()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getRole () {
      this.$axios
        .get('api/advice/role')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.roleOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getCate () {
      this.$axios
        .get('api/advice/cate')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.cateOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getCateEdit () {
      this.$axios
        .get('api/advice/cate')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.cateEditOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    readRecord (row) {
      let newPage = this.$router.resolve({
        path: '/documentation',
        query: { url: row.body }
      })
      window.open(newPage.href, '_blank')

      this.$axios
        .post('api/advice/readrecord', {
          id: row.id,
          title: row.title
        })
        .then(({ data }) => {
          if (data.code === 1) {
            // this.comNoticeData = data.data.data
            // this.total = data.data.total
          }
        })
        .catch()
    },
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanys(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
        }
      })
    },
    searchRemoteCompanyMethodS (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanysx(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompaniesx = []
      }
    },
    searchArrItemCompanysx (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompaniesx = data.data.companies
        }
      })
    },
    // 监听粘贴操作
    handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit() // 提交图片上传队列
    },

    handleRemove (file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
    },

    handlePictureCardPreview (file) {
      this.dialogVisible = true
      this.dialogImageUrl = file.url
    },
    handleAvatarSuccess (res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleAvatarChange (res, file) {
      this.fileList = file
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片格式为JPG或PNG!')
        return
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      // return isJPG && isLt2M
    },
    editHandlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      if (this.editFileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.editUploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.editUploadMutiple.submit() // 提交图片上传队列
    },

    editHandleRemove (file, fileList) {
      // this.editFileList.map((item, index) => {
      //   if (item.uid === file.uid) {
      //     this.editFileList.splice(index, 1)
      //   }
      // })
      this.editFileList = fileList
      this.change = true
    },

    editHandlePictureCardPreview (file) {
      this.dialogVisibleE = true
      this.dialogImageUrlE = file.url
    },
    editHandleAvatarSuccess (res, file) {
      if (res.code === 1) {
        this.editNeedUrl.push({ url: res.url, name: file.name })
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    editHandleAvatarChange (res, file) {
      this.editFileList = file
      this.change = true
    },
    editBeforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片格式为JPG或PNG!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    openCompanyCom (row) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyComId = row.companyId
      })
    },
    resetForm (formName) {
      this.visible = false
      this.$refs[formName].resetFields()
    },
    doSearch () {
      this.visible = false
      this.loadSingle()
    },
    toSearch (val) {
      this.loadTable()
    },
    setRow (evt, row) {
      this.$axios
        .put('api/advice/setas', {
          id: row.id,
          is_use: evt
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.loadTable()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    }
  },
  watch: {
    comId: function (val) {
      if (val) {
        this.$refs.uploadMutiple.clearFiles()
        this.activeTabName = 'first'
      }
    }
  }
}
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/common/TaxAdvice.vue